var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Inner Ellipse",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#022219",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Middle Ellipse",
    cx: 6,
    cy: 6,
    r: 4.125,
    fill: "#022219",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Outter Ellipse",
    cx: 6,
    cy: 6,
    r: 2.625,
    fill: "#9DEA6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDot);
export default __webpack_public_path__ + "static/media/active_dot.9af86128316da56c8d332edfed81bc65.svg";
export { ForwardRef as ReactComponent };